module.exports = __webpack_public_path__ + "img/banner.c74df500.png";